import i18n from '@shared/config/i18n';
import { ChildBase, ValuesSpec } from '../defaults';

const { t } = i18n;

type Item = {
  id: string;
  title: string;
  price: string;
  status: string;
  helperText: string;
  paymentTypesList: ValuesSpec[];
};

/* eslint-disable */
export const marketOrderItem = ({ id, title, price, status, paymentTypesList }: Item) => {
  return {
    spec: 'controls-horizontal',
    token: `${id}_horizontal-market-order`,
    data: {},
    styles: {
      display: 'flex',
      gap: 8,
      width: '100%',
      boxSizing: 'border-box',
    },
    child: [
      {
        spec: 'input-text',
        token: `${id}_title`,
        data: {
          label: t('Order'),
          value: title,
          type: 'text',
          multiline: true,
          readOnly: true,
          canChangeReadonly: false,
        },
        styles: { wordBreak: 'break-all' },
      },

      {
        spec: 'input-text',
        token: `${id}_price`,
        styles: { flex: '1 1 30%', minWidth: '120px' },
        data: {
          label: t('OrderAmount'),
          value: price,
          type: 'number',
          customData: {
            clearable: true,
            sxMui: {
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0,
              },
              '& input[type=number]': { '-moz-appearance': 'textfield' },
            },
          },

          readOnly: true,
          canChangeReadonly: false,
        },
      },

      {
        spec: 'input-select',
        token: `${id}_status`,
        styles: { flex: '1 1 30%', minWidth: '220px' },
        data: {
          label: t('Label.status'),
          value: status,
          values: {
            kind: 'const',
            spec: paymentTypesList,
          },
          customData: {
            select: {
              notMultipleReadonlyAsChip: true,
            },
          },
          readOnly: true,
          canChangeReadonly: false,
        },
        child: [],
      },
    ],
  } as ChildBase;
};
/* eslint-enable */
